import useSWR from 'swr';

import { fetcher } from '@/utils/swr-utils';
import { MODELS_PATH } from './paths';
import { IModelDetails } from '@/models/IModelDetails';

export default function useModelDetails(aggregateId: string) {
  const key = `${MODELS_PATH}/${aggregateId}`;
  const { data, error, isLoading } = useSWR<IModelDetails>(key, fetcher);

  return { model: data, isLoading, isError: Boolean(error) };
}
